import React from "react"

import PinterestPins from "./PinterestPins"
import "./PinterestStep.scss"

import analytics from "global/AnalyticsData"


const PinterestStep = ({ step, onEngage = function () {}, onAwardPoints = function () {}, nextStepButton, skipButton }) => {

	let awarded = false

	// an onload if we need it
    const pinterestLoaded = () => {
    	// console.log("[Pinterest Step] Pinterest step start")
    }

  //This step is triggered complete when pins are intereacted with.
  const onPinInteract = (pinID) => {
	if (!awarded) {
		onEngage()
		onAwardPoints()	
		awarded = true
	}

    analytics.stepEvent("step_interaction_pinterest_pin_click", step, {
        result: `https://www.pinterest.com/pin/${pinID}/`,
        result_id: pinID
    })
    
  }
  
  // pin data in beaker may not be formated well. clean it up.
  let pinArr = []
  if (step.pinterest && step.pinterest.pinIds) {
    pinArr = step.pinterest.pinIds.split(" ").join("").split(",")
  }


  return (
    <section className={`pinterest-step-container`}>
		{ step && step.pinterest && (
			<div className={`step-content with-shadow`}>
				<div className={`pinterest-step--copy`}>
					{step.pinterest.headline && <h2 className="pinterest-step--headline" dangerouslySetInnerHTML={{ __html: step.pinterest.headline }} />}
					{step.pinterest.introCopy && <h3 className="pinterest-step--subhead" dangerouslySetInnerHTML={{ __html: step.pinterest.introCopy }} />}
					{step.pinterest.bodyCopy && <p className="pinterest-step--body" dangerouslySetInnerHTML={{ __html: step.pinterest.bodyCopy }} />}
				</div>
				<PinterestPins onLoad={pinterestLoaded} onPinInteract={onPinInteract} pinIDs={pinArr} />
        {skipButton}
        {nextStepButton}
			</div>
		)}
    </section>
  )
}
export default PinterestStep
